module.exports = __webpack_public_path__ + "static/media/tick.ed879c63.svg";